import { render } from "./MultipleChoice.vue?vue&type=template&id=7887ecd2&scoped=true&ts=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"

import "./MultipleChoice.vue?vue&type=style&index=0&id=7887ecd2&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7887ecd2"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
